var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01562 15.7706C10.9763 13.9599 13.5973 12.8535 16.4767 12.8535C19.3561 12.8535 21.9771 13.9599 23.9379 15.7706M12.407 19.4447C13.4765 18.457 14.9062 17.8535 16.4767 17.8535C18.0473 17.8535 19.477 18.457 20.5464 19.4447",
    stroke: "#383B41",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7044 23.2096C17.7044 23.8874 17.155 24.4368 16.4772 24.4368C15.7994 24.4368 15.25 23.8874 15.25 23.2096C15.25 22.5319 15.7994 21.9824 16.4772 21.9824C17.155 21.9824 17.7044 22.5319 17.7044 23.2096Z",
    fill: "#383B41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 12.0966C8.47694 9.46274 12.2893 7.85352 16.4775 7.85352C20.6658 7.85352 24.4781 9.46274 27.3301 12.0966",
    stroke: "#E6E9ED",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork2);
export default __webpack_public_path__ + "static/media/network-2.733fa35b0d0ba687ce22c9ce2039c6ff.svg";
export { ForwardRef as ReactComponent };